import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["digit"]

  connect() {
    // Focus first input on connect
    if (this.digitTargets.length > 0) {
      this.digitTargets[0].focus()
    }
  }

  handleInput(event) {
    const input = event.target
    const index = parseInt(input.dataset.index)
    const value = input.value

    // Only allow digits
    if (!/^\d*$/.test(value)) {
      input.value = value.replace(/\D/g, "")
      return
    }

    // If a digit was entered, move to next input
    if (value.length === 1 && index < this.digitTargets.length - 1) {
      this.digitTargets[index + 1].focus()
    }

    this.updateVerifyButton()
  }

  handleKeydown(event) {
    const input = event.target
    const index = parseInt(input.dataset.index)

    // Handle backspace
    if (event.key === "Backspace" && input.value === "" && index > 0) {
      this.digitTargets[index - 1].focus()
      this.digitTargets[index - 1].value = ""
    }

    // Handle arrow keys
    if (event.key === "ArrowLeft" && index > 0) {
      event.preventDefault()
      this.digitTargets[index - 1].focus()
    }
    if (event.key === "ArrowRight" && index < this.digitTargets.length - 1) {
      event.preventDefault()
      this.digitTargets[index + 1].focus()
    }

    this.updateVerifyButton()
  }

  handlePaste(event) {
    event.preventDefault()
    const pastedData = (event.clipboardData || window.clipboardData).getData("text")
    const digits = pastedData.replace(/\D/g, "").slice(0, 6)

    digits.split("").forEach((digit, index) => {
      if (this.digitTargets[index]) {
        this.digitTargets[index].value = digit
      }
    })

    // Focus the next empty input or the last one
    const nextEmptyIndex = digits.length < 6 ? digits.length : 5
    if (this.digitTargets[nextEmptyIndex]) {
      this.digitTargets[nextEmptyIndex].focus()
    }

    this.updateVerifyButton()
  }

  updateVerifyButton() {
    const otp = this.digitTargets.map(input => input.value).join("")
    const verifyButton = document.querySelector('[data-profile-settings-target="verifyButton"]')
    if (verifyButton) {
      verifyButton.disabled = otp.length !== 6
    }
  }

  getOtp() {
    return this.digitTargets.map(input => input.value).join("")
  }

  clear() {
    this.digitTargets.forEach((input, index) => {
      input.value = ""
      if (index === 0) input.focus()
    })
    this.updateVerifyButton()
  }
}
